import { Channel } from './ChannelType';

export enum HardwareTypeEnum {
  Kiosk = 'Kiosk',
}

export type Hardware = {
  id: string;
  name: string;
  apiKey: string;
  createdBy: string;
  createdAt: Date | undefined;
  updatedBy: string;
  updatedAt: Date | undefined;
  status: string;
  type: string;
  channel: Channel;
  hardwareSettings: HardwareSettings | undefined;
  deviceInfo?: HardwareDeviceInfo | null;
  location?: string | undefined;
  notes?: string | undefined;
};

export type HardwareSettings = {};

export type HardwareDeviceInfo = {
  lastActivityAt?: Date;
};
